import { type FC, useEffect } from 'react';

import { FeatureVariant } from '@vakantiesnl/components/src/atoms/FeatureVariant';
import { StickyOfferWrapper } from '@vakantiesnl/components/src/blocks/accommodation/StickyOfferWrapper/StickyOfferWrapper';
import { AccommodationSections } from '@vakantiesnl/components/src/utils/accoSections';
import { useAccommodationContext } from '@vakantiesnl/services/src/context/useAccommodationContext';
import { useTripFilterContext } from '@vakantiesnl/services/src/context/useTripFilterContext';
import { useAccoOfferStore } from '@vakantiesnl/services/src/stores/accommodationStore';
import dynamic from 'next/dynamic';
import { Element } from 'react-scroll';

import { useCustomStyles } from './accommodation.styles';
import PriceOverview from './price-overview';
import { PackageTripOffersInfiniteScroll } from './trip-offers/PackageTripOffersInfiniteScroll';

const Flights = dynamic(import('@vakantiesnl/components/src/blocks/accommodation/Flights/Flights'), {
	ssr: false,
});

/** When implementing VariantB don't forget to check the microcopies for vakanties */
const FlightsVariantB = dynamic(
	import('@vakantiesnl/components/src/blocks/accommodation/FlightsVariantB/Flights').then(
		(mod) => mod.FlightsVariantB,
	),
	{
		ssr: false,
	},
);
const RoomType = dynamic(import('@vakantiesnl/components/src/blocks/accommodation/RoomType/RoomType'), {
	ssr: false,
});
const MealPlan = dynamic(import('@vakantiesnl/components/src/blocks/accommodation/MealPlan/MealPlan'), {
	ssr: false,
});

type Props = {
	isPriceInView?: boolean;
};

export const AccommodationBookingModule: FC<Props> = ({ isPriceInView }) => {
	const {
		state: { mealPlanData },
	} = useAccommodationContext();
	const {
		state: { invalidPreselection },
	} = useTripFilterContext();

	const { classes } = useCustomStyles();

	const selected = useAccoOfferStore((s) => s.departureDateOffer);

	useEffect(() => {
		if (window && window.scrollTo) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}, []);

	return (
		<div className={classes.bookingModule}>
			<Element name={AccommodationSections.AvailabilityOffers}>
				<PackageTripOffersInfiniteScroll />
			</Element>
			{selected && !invalidPreselection && (
				<>
					<FeatureVariant
						featureName="exp-flight-alternatives"
						variantName="VariantB"
						defaultChildren={<Flights />}
					>
						<FlightsVariantB />
					</FeatureVariant>

					<RoomType />
					<MealPlan />
					<PriceOverview />
					<StickyOfferWrapper isPriceInView={isPriceInView} isLoadingOffers={mealPlanData?.loading} />
				</>
			)}
		</div>
	);
};
